// src/pages/Empleados.jsx
import { useState, useEffect } from 'react';
import { getEmployees, saveEmployee, deleteEmployee, getPosts } from '../data/store';
import { useAuth } from '../hooks/useAuth';

const BLANK = { name:'', position:'Guardia', phone:'', email:'', employeeId:'', type:'fulltime', restrictions:[], notes:'' , ssn4:'', assignedPostIds:[], clock_in_enabled:true};
const RESTRICTION_OPTIONS = [
  { value:'only_day',    label:'Solo turno diurno (6am-6pm)' },
  { value:'only_night',  label:'Solo turno nocturno (6pm-6am)' },
  { value:'no_weekend',  label:'No trabaja fines de semana' },
  { value:'no_monday',   label:'No disponible lunes' },
  { value:'no_tuesday',  label:'No disponible martes' },
  { value:'no_wednesday', label:'No disponible miercoles' },
  { value:'no_thursday', label:'No disponible jueves' },
  { value:'no_friday',   label:'No disponible viernes' },
];

const S = {
  page: { color:'#fff' },
  header: { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem' },
  title: { fontSize:'1.6rem', fontWeight:800, color:'#F5C518', margin:0 },
  btn: { background:'#F5C518', color:'#000', border:'none', borderRadius:8, padding:'10px 20px', fontWeight:700, cursor:'pointer', fontSize:14 },
  btnRed: { background:'rgba(220,38,38,0.15)', color:'#f87171', border:'1px solid rgba(220,38,38,0.3)', borderRadius:6, padding:'6px 12px', cursor:'pointer', fontSize:12 },
  btnEdit: { background:'rgba(245,197,24,0.15)', color:'#F5C518', border:'1px solid rgba(245,197,24,0.3)', borderRadius:6, padding:'6px 12px', cursor:'pointer', fontSize:12 },
  card: { background:'#1a1a1a', border:'1px solid #222', borderRadius:12, padding:'1.25rem', display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 },
  badge: (color) => ({ background:'rgba('+color+',0.15)', border:'1px solid rgba('+color+',0.3)', borderRadius:4, padding:'2px 8px', fontSize:11 }),
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:100, display:'flex', alignItems:'center', justifyContent:'center', padding:20 },
  modal: { background:'#1a1a1a', border:'1px solid #333', borderRadius:16, padding:'2rem', width:'100%', maxWidth:500, maxHeight:'90vh', overflowY:'auto' },
  label: { display:'block', color:'#888', fontSize:12, marginBottom:4, marginTop:16 },
  input: { width:'100%', padding:'10px 12px', background:'#0d0d0d', border:'1px solid #333', borderRadius:8, color:'#fff', fontSize:14, boxSizing:'border-box' },
};

export default function Empleados() {
  const { can } = useAuth();
  const [employees, setEmployees] = useState([]);
  const [posts, setPosts] = useState([]);
  const [employeePostLinks, setEmployeePostLinks] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(BLANK);
  const [search, setSearch] = useState('');
  const [pinIds, setPinIds] = useState([]);

  const canEdit = can('canEditEmployees');

  const postIdsForEmployee = (empId) =>
    employeePostLinks.filter(l => String(l.employee_id) === String(empId)).map(l => l.post_id);

  const reload = async () => {
    try {
      const data = await getEmployees();
      setEmployees(Array.isArray(data) ? data : []);
    } catch (err) { console.error('Error cargando empleados:', err); }
    try {
      const pts = await getPosts();
      setPosts(Array.isArray(pts) ? pts : []);
    } catch (err) { console.error('Error cargando puestos:', err); }
    try {
      const pinRes = await fetch('/api/has-pin');
      const pinData = await pinRes.json();
      setPinIds(Array.isArray(pinData.employeeIds) ? pinData.employeeIds : []);
    } catch (err) { console.error('Error cargando pines:', err); }
    try {
      const epRes = await fetch('/api/employee-posts');
      const epData = await epRes.json();
      setEmployeePostLinks(Array.isArray(epData.links) ? epData.links : []);
    } catch (err) { console.error('Error cargando asignaciones de puesto:', err); }
  };
  useEffect(() => { reload(); }, []);

  const open = (emp = null) => {
    if (!canEdit) return;
    setForm(emp ? {
      ...emp,
      employeeId: emp.badge || emp.employeeId || '',
      type: emp.type === 'part-time' ? 'parttime' : 'fulltime',
      restrictions: emp.preferred_shifts || emp.restrictions || [],
      ssn4: '',
      assignedPostIds: postIdsForEmployee(emp.id),
    } : { ...BLANK });
    setModal(true);
  };
  const close = () => setModal(false);

  const save = async () => {
    if (!canEdit) return;
    if (!form.name.trim()) { alert('El nombre es requerido'); return; }
    const ssn4Digits = String(form.ssn4 || '').replace(/\D/g,'');
    if (!form.id && ssn4Digits.length !== 4) { alert('Los ultimos 4 del Seguro Social son requeridos (4 digitos) para poder usar el Clock In / Clock Out.'); return; }
    if (form.id && ssn4Digits.length > 0 && ssn4Digits.length < 4) { alert('Completa los 4 digitos del Seguro Social o dejalo en blanco para no cambiarlo.'); return; }
    try {
      const savedEmp = await saveEmployee({
        id: (form.id !== undefined && form.id !== null && form.id !== '') ? form.id : undefined,
        name: form.name,
        badge: form.employeeId || form.badge || 'G-' + Date.now(),
        type: form.type === 'parttime' ? 'part-time' : 'full-time',
        phone: form.phone || null,
        email: form.email || null,
        status: 'active',
        preferred_shifts: form.restrictions || [],
        max_hours_per_week: form.type === 'parttime' ? 24 : 40,
        clock_in_enabled: typeof form.clock_in_enabled === 'boolean' ? form.clock_in_enabled : (form.id ? undefined : true),
      });
      if (/^\d{4}$/.test(String(form.ssn4 || '')) && savedEmp && savedEmp.id) {
        try {
          await fetch('/api/set-pin', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ employeeId: savedEmp.id, ssn4: form.ssn4 }) });
        } catch (pinErr) {
          console.error('No se pudo guardar el PIN', pinErr);
          alert('El empleado se guardo pero el PIN no se pudo actualizar. Intenta de nuevo desde Editar.');
        }
      }
      const empIdForPosts = (savedEmp && savedEmp.id) || form.id;
      if (empIdForPosts) {
        try {
          await fetch('/api/employee-posts', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ employeeId: empIdForPosts, postIds: form.assignedPostIds || [] }) });
        } catch (epErr) {
          console.error('No se pudieron guardar los puestos asignados', epErr);
        }
      }
      await reload();
      close();
    } catch (err) {
      console.error('Error guardando empleado:', err);
      alert('No se pudo guardar el empleado. Verifica que el ID/badge no este repetido.');
    }
  };

  const del = async (id) => {
    if (!canEdit) return;
    if (window.confirm('Eliminar este empleado?')) { await deleteEmployee(id); await reload(); }
  };

  const toggleClockIn = async (emp) => {
    if (!canEdit) return;
    try {
      await saveEmployee({ id: emp.id, clock_in_enabled: !emp.clock_in_enabled });
      await reload();
    } catch (err) {
      console.error('Error actualizando el estado de Clock In:', err);
      alert('No se pudo actualizar el estado de Clock In para este empleado.');
    }
  };

  const toggleRestriction = (val) =>
    setForm(f => ({
      ...f,
      restrictions: f.restrictions?.includes(val)
        ? f.restrictions.filter(r => r !== val)
        : [...(f.restrictions || []), val],
    }));

  const toggleAssignedPost = (postId) =>
    setForm(f => ({
      ...f,
      assignedPostIds: (f.assignedPostIds || []).includes(postId)
        ? f.assignedPostIds.filter(p => p !== postId)
        : [...(f.assignedPostIds || []), postId],
    }));

  const filtered = Array.isArray(employees)
    ? employees.filter(e => (e.name || '').toLowerCase().includes(search.toLowerCase()))
    : [];

  const restrictionLabel = { only_day:'Solo dia', only_night:'Solo noche', no_weekend:'Sin fines de semana', no_monday:'Sin lunes', no_tuesday:'Sin martes', no_wednesday:'Sin miercoles', no_thursday:'Sin jueves', no_friday:'Sin viernes' };

  return (
    <div style={S.page}>
      <div style={S.header}>
        <div>
          <h1 style={S.title}>Empleados</h1>
          <p style={{ color:'#666', margin:'4px 0 0', fontSize:14 }}>{employees.length} empleados registrados</p>
        </div>
        {canEdit && (
          <button style={S.btn} onClick={() => open()}>+ Anadir empleado</button>
        )}
      </div>

      <input placeholder="Buscar empleado..." value={search} onChange={e => setSearch(e.target.value)}
        style={{ ...S.input, marginBottom:20, maxWidth:320 }} />

      {filtered.map(emp => (
        <div key={emp.id} style={S.card}>
          <div style={{ flex:1 }}>
            <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:6 }}>
              <div style={{ width:38, height:38, borderRadius:'50%', background:'rgba(245,197,24,0.15)', border:'1px solid rgba(245,197,24,0.3)', display:'flex', alignItems:'center', justifyContent:'center', color:'#F5C518', fontWeight:700, fontSize:14, flexShrink:0 }}>
                {emp.name.charAt(0).toUpperCase()}
              </div>
              <div>
                <div style={{ fontWeight:600, fontSize:15 }}>{emp.name}</div>
                <div style={{ color:'#666', fontSize:12 }}>{(emp.badge || emp.employeeId) && 'ID: ' + (emp.badge || emp.employeeId) + ' - '}{emp.position || 'Guardia'}</div>
              </div>
            </div>
            <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginTop:6 }}>
              <span style={S.badge('245,197,24')}>{emp.type === 'part-time' || emp.type === 'parttime' ? 'Part-time' : 'Full-time'}</span>
              <span
                style={{ ...S.badge(emp.clock_in_enabled ? '34,197,94' : '148,163,184'), cursor: canEdit ? 'pointer' : 'default', userSelect:'none' }}
                onClick={() => canEdit && toggleClockIn(emp)}
                title={canEdit ? 'Click para activar/desactivar el Clock In' : ''}
              >
                {emp.clock_in_enabled ? 'Clock In: ON' : 'Clock In: OFF'}
              </span>
              {postIdsForEmployee(emp.id).map(pid => {
                const post = posts.find(p => String(p.id) === String(pid));
                return post ? <span key={pid} style={S.badge('59,130,246')}>{post.name}</span> : null;
              })}
              {(emp.preferred_shifts || emp.restrictions || []).map(r => (
                <span key={r} style={S.badge('239,68,68')}>{restrictionLabel[r] || r}</span>
              ))}
            </div>
            {emp.phone && <div style={{ color:'#555', fontSize:12, marginTop:6 }}>Tel: {emp.phone}</div>}
          </div>
          {canEdit && (
            <div style={{ display:'flex', gap:8, flexShrink:0 }}>
              <button style={S.btnEdit} onClick={() => open(emp)}>Editar</button>
              <button style={S.btnRed} onClick={() => del(emp.id)}>Eliminar</button>
            </div>
          )}
        </div>
      ))}

      {filtered.length === 0 && (
        <div style={{ textAlign:'center', color:'#444', padding:'3rem' }}>
          {search ? 'No se encontraron empleados.' : 'No hay empleados.'}
        </div>
      )}

      {modal && canEdit && (
        <div style={S.overlay} onClick={e => e.target === e.currentTarget && close()}>
          <div style={S.modal}>
            <h2 style={{ color:'#F5C518', margin:'0 0 1rem', fontSize:18 }}>
              {form.id && employees.find(e => e.id === form.id) ? 'Editar' : 'Nuevo'} Empleado
            </h2>
            <label style={S.label}>Nombre completo *</label>
            <input style={S.input} value={form.name} onChange={e => setForm({...form, name:e.target.value})} placeholder="Ej. Juan Perez" />
            <label style={S.label}>ID de empleado</label>
            <input style={S.input} value={form.employeeId||''} onChange={e => setForm({...form, employeeId:e.target.value})} placeholder="Ej. EMP-001" />
            <label style={S.label}>Puesto</label>
            <input style={S.input} value={form.position||''} onChange={e => setForm({...form, position:e.target.value})} placeholder="Guardia" />
            <label style={S.label}>Tipo de empleado</label>
            <select style={S.input} value={form.type||'fulltime'} onChange={e => setForm({...form, type:e.target.value})}>
              <option value="fulltime">Full-time</option>
              <option value="parttime">Part-time</option>
            </select>
            <label style={S.label}>Telefono</label>
            <input style={S.input} value={form.phone||''} onChange={e => setForm({...form, phone:e.target.value})} placeholder="787-000-0000" />
            <label style={S.label}>Email</label>
            <input style={S.input} value={form.email||''} onChange={e => setForm({...form, email:e.target.value})} placeholder="correo@ejemplo.com" />
            <label style={S.label}>PIN de acceso - ultimos 4 del Seguro Social *</label>
            <input style={{...S.input, letterSpacing:6, fontSize:18, fontWeight:700, textAlign:'center'}} type="text" inputMode="numeric" pattern="[0-9]*" autoComplete="off" maxLength={4} value={form.ssn4||''} onChange={e => setForm({...form, ssn4:e.target.value.replace(/\D/g,'').slice(0,4)})} placeholder={form.id ? 'Dejar en blanco para no cambiar' : '4 digitos (requerido)'} />
            {form.id && pinIds.includes(form.id) && <div style={{color:'#4ade80', fontSize:12, marginTop:6}}>PIN configurado</div>}
            <label style={S.label}>Puestos asignados (donde puede hacer Clock In)</label>
            <div style={{ display:'flex', flexDirection:'column', gap:8, marginTop:4 }}>
              {posts.length === 0 && <div style={{ color:'#555', fontSize:12 }}>No hay puestos creados todavia.</div>}
              {posts.map(post => (
                <label key={post.id} style={{ display:'flex', alignItems:'center', gap:8, color:'#ccc', fontSize:13, cursor:'pointer' }}>
                  <input type="checkbox" checked={(form.assignedPostIds||[]).includes(post.id)} onChange={() => toggleAssignedPost(post.id)} />
                  {post.name}
                </label>
              ))}
            </div>
            <label style={S.label}>Restricciones de turno</label>
            <div style={{ display:'flex', flexDirection:'column', gap:8, marginTop:4 }}>
              {RESTRICTION_OPTIONS.map(opt => (
                <label key={opt.value} style={{ display:'flex', alignItems:'center', gap:8, color:'#ccc', fontSize:13, cursor:'pointer' }}>
                  <input type="checkbox" checked={form.restrictions?.includes(opt.value)||false} onChange={() => toggleRestriction(opt.value)} />
                  {opt.label}
                </label>
              ))}
            </div>
            <label style={S.label}>Notas</label>
            <textarea style={{ ...S.input, height:80, resize:'vertical' }} value={form.notes||''} onChange={e => setForm({...form, notes:e.target.value})} placeholder="Notas adicionales..." />
                          <label style={{ ...S.label, display:'flex', alignItems:'center', gap:8, cursor:'pointer', color:'#ccc', fontSize:13, marginTop:16 }}>
                                            <input type="checkbox" checked={form.clock_in_enabled !== false} onChange={(e) => setForm({...form, clock_in_enabled: e.target.checked})} />
                                            Habilitar Clock In (permite marcar entrada/salida en la app)
                          </label>
            <div style={{ display:'flex', gap:10, marginTop:20 }}>
              <button style={{ ...S.btn, flex:1 }} onClick={save}>Guardar</button>
              <button style={{ ...S.btnRed, flex:1 }} onClick={close}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
